<style scoped>
.header-footer-wrap {
  padding-top: 90px;
}
.header-footer-wrap .banner-wrap {
  height: 498px;
  overflow: hidden;
}
.header-footer-wrap .banner-wrap-cur {
  display: none;
}
</style>

<template>
  <div class="header-footer-wrap">
    <transition>
      <nav-bar v-if="navChange" @change="navbarItemClicked"></nav-bar>
    </transition>
    <transition>
      <nav-bar
        v-if="!navChange"
        @change="navbarItemClicked"
        operateStyle
      ></nav-bar>
    </transition>
    <div
      v-if="currentIndex != 0"
      :class="{ 'banner-wrap': true, 'banner-wrap-cur': noBanner }"
    >
      <banner
        v-if="!noBanner"
        :img-url="currentBanner.img"
        :bgfill="currentBanner.bgfill"
      ></banner>
      <banner
        v-else
        no-banner
        :img-url="currentBanner.img"
        :bgfill="currentBanner.bgfill"
      ></banner>
    </div>
    <div v-else>
      <banner
        v-if="noBanner"
        no-banner
        :img-url="currentBanner.img"
        :bgfill="currentBanner.bgfill"
      ></banner>
      <ic-slider v-else :autoplay="3000">
        <ic-slider-item v-for="(items, index) in images" :key="index">
          <div
            :style="
              'background: ' +
              items.bgfill +
              ' url(' +
              items.img +
              ') no-repeat center center'
            "
          ></div>
        </ic-slider-item>
      </ic-slider>
    </div>
    <slot></slot>
    <cfooter></cfooter>
    <transition>
      <go-top-image
        v-show="!navChange"
        @change="goTopImageClicked"
      ></go-top-image>
    </transition>
    <open-mobile></open-mobile>
    <download-app></download-app>
    <telephone></telephone>
  </div>
</template>

<script>
import NavBar from "./NavBar";
import Banner from "./Banner";
import Cfooter from "./CFooter";
import GoTopImage from "./GoTopImage";
import Telephone from "./Telephone";
import DownloadApp from "./DownloadApp.vue";
import OpenMobile from "./OpenMobile.vue";
import communicate from "../../../communicate";
import { IcSlider, IcSliderItem } from "vue-better-slider";

export default {
  name: "header_footer",
  components: {
    NavBar,
    Banner,
    Cfooter,
    GoTopImage,
    Telephone,
    DownloadApp,
    OpenMobile,
    IcSlider,
    IcSliderItem,
  },
  props: {
    noBanner: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      clientHeight: 0,
      scrollHeight: 0,
      navChange: true,
      // currentBanner: require('../../../assets/image/banner/banner_home.jpg'),
      currentBanner: {
        img: require("../../../assets/image/banner/banner_home.jpg"),
        bgfill: "#eee",
      },
      currentIndex: 0,
      banners: [
        {
          img: require("../../../assets/image/banner/banner_home01.png"),
          bgfill: "#fff",
        },
        {
          img: require("../../../assets/image/banner/banner_chain.png"),
          bgfill: "#0d1a41",
        },
        {
          img: require("../../../assets/image/banner/banner_ys.png"),
          bgfill: "#fff",
        },
        {
          img: require("../../../assets/image/banner/banner_cooperation.jpg"),
          bgfill: "#fff",
        },
        {
          img: require("../../../assets/image/banner/banner_new.jpg"),
          bgfill: "#fff",
        },
        {
          img: require("../../../assets/image/banner/banner_about.png"),
          bgfill: "#fff",
        },
        {
          img: require("../../../assets/image/banner/banner_news.png"),
          bgfill: "#fff",
        },
        {
          img: require("../../../assets/image/banner/banner_link.jpg"),
          bgfill: "#fff",
        },
        {
          img: require("../../../assets/image/banner/banner_link.jpg"),
          bgfill: "#fff",
        },
      ],
      menuBanners: [
        {
          img: require("../../../assets/image/banner/banner_chain.png"),
          bgfill: "#0d1a41",
        },
        {
          img: require("../../../assets/image/banner/banner_zfds.png"),
          bgfill: "#fff",
        },
        {
          img: require("../../../assets/image/banner/banner_ys.png"),
          bgfill: "#fff",
        },
        {
          img: require("../../../assets/image/banner/banner_bms.jpg"),
          bgfill: "#fff",
        },
        {
          img: require("../../../assets/image/banner/banner_manage.jpg"),
          bgfill: "#fff",
        },
        {
          img: require("../../../assets/image/banner/banner_dispatch.jpg"),
          bgfill: "#fff",
        },
      ],
      images: [
        {
          img: require("../../../assets/image/banner/banner_home03.jpg"),
          bgfill: "#fff",
        },
        {
          img: require("../../../assets/image/banner/banner_home04.jpg"),
          bgfill: "#fff",
        },
        {
          img: require("../../../assets/image/banner/banner_home01.png"),
          bgfill: "#fff",
        },
        {
          img: require("../../../assets/image/banner/banner_home02.png"),
          bgfill: "#fff",
        },
      ],
    };
  },
  methods: {
    sliderClicked() {
      communicate.$emit("navItemChange", 5); //6是底部不存在的index
      this.goTopImageClicked();
    },
    goTopImageClicked() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    navbarItemClicked(item, index) {
      this.goTopImageClicked();
      console.log("navbarItemClicked", index);
      if (index == 0) {
        this.$router.push({ name: "home" });
      } else if (index == 1) {
        this.$router.push({ name: "chain" });
      } else if (index == 2) {
        this.$router.push({ name: "product_tms" });
      } else if (index == 3) {
        this.$router.push({ name: "cooperation" });
      } else if (index == 4) {
        this.$router.push({ name: "news_list" });
      } else if (index == 5) {
        this.$router.push({ name: "success" });
      } else if (index == 6) {
        this.$router.push({ name: "about" });
      } else if (index == 7) {
        this.$router.push({ name: "contact" });
      } else if (index == 8) {
        this.$router.push({ name: "link" });
      }
      if (index != 8) {
        this.currentIndex = index;
        this.currentBanner = this.banners[index];
      }
      this.goTopImageClicked();
    },
    // menuPickerClicked(item, index) {
    //     if (index == 0) {
    //         this.$router.push({name: 'product_wms'})
    //     } else if (index == 1) {
    //         this.$router.push({name: 'product_oms'})
    //     } else if (index == 2) {
    //         this.$router.push({name: 'product_tms'})
    //     } else if (index == 3) {
    //         // window.open('http://trade.meyoung.cn/index.php?route=product/category&path=33', '_blank')
    //     }
    //     this.currentIndex = 'menu' + index
    //     this.currentBanner = this.menuBanners[index]
    //     this.goTopImageClicked()
    // },
    scrollData() {
      this.scrollHeight =
        document.documentElement.scrollTop || document.body.scrollTop;
      if (this.scrollHeight >= 500) {
        this.navChange = false;
      } else {
        this.navChange = true;
      }
    },
  },
  mounted() {
    // this.clientHeight = `${document.documentElement.clientHeight}`
    // window.onresize = function temp() {
    //     this.clientHeight = `${document.documentElement.clientHeight}`
    // }
    window.addEventListener("scroll", this.scrollData);
  },
  created() {
    let currentIndex = sessionStorage.getItem("nav_item_index");
    if (currentIndex) {
      this.currentIndex = currentIndex;
      if (currentIndex.indexOf("menu") > -1) {
        this.currentBanner = this.menuBanners[currentIndex.replace("menu", "")];
      } else {
        this.currentBanner = this.banners[currentIndex];
      }
    } else {
      //   this.currentBanner = require("../../../assets/image/banner/banner_home.jpg");
      this.currentBanner = {
        img: require("../../../assets/image/banner/banner_home.jpg"),
        bgfill: "#fff",
      };
      console.log("svip-this.currentBanner", this.currentBanner);
    }
  },
};
</script>




// WEBPACK FOOTER //
// src/components/page/common/HeaderFooter.vue